import { Component, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';
import { ProfileService } from '../../../services/profile.service';
import { DataType } from '../../../models/data-type.model';
import { Tag } from '../../../models/tag.model';
import Utils from '../../../services/utils';
import { TagService } from '../../../services/tag.service';
import { DataService } from '../../../services/data.service';
import { ToastService } from '../../../components/toast/toast.service';

@Component({
  selector: 'lowy-edit-tag',
  templateUrl: './edit-tags.component.html',
  styleUrls: ['./edit-tags.component.scss'],
  providers: [ TagService ]
})
export class EditTagsComponent implements OnInit {

  // dropdown mgmt
  filteredTags: Array<Tag>;
  selectedTagType: DataType;

  dataTypes: Array<DataType>;
  filteredDataTypes: Array<DataType>;
  dataType: DataType;
  data: any;

  allTags: Array<Tag>;

  pendingActions: Array<{
    add: boolean,
    tag: Tag
  }>;

  tagGroups: {
    [key: number]: any
  };

  dataTypeLookup: {
    [key: number]: string
  } = {
    1: 'Patient',
    2: 'Image'
  };

  @ViewChild('modal') modal: ModalComponent;
  @Output() updated = new EventEmitter<any>();

  constructor(private tagService: TagService, private dataService: DataService, private toastService: ToastService) {
    this.pendingActions = [];
  }

  async ngOnInit() {
    this.dataTypes = await this.dataService.getDataTypes();
    this.allTags = await this.tagService.getTags();
  }

  public open(tags: Array<Tag>, data: any, dataTypeAbbr: string) {
    this.tagGroups = this.groupTags(tags);
    this.data = data;
    this.filteredDataTypes = [];
    this.dataTypes.forEach(dataType => {
      if (dataType.abbr === dataTypeAbbr) {
        this.dataType = dataType;
      }
    });

    this.filteredTags = [];
    this.allTags.forEach(tag => {
      if (tag.dataTypeId === this.dataType.dataTypeId) {
        this.filteredTags.push(tag);
      }
    });

    this.modal.open();
  }

  async save() {
    for (let i = 0; i < this.pendingActions.length; i++) {
      const payload = {
        tagId: this.pendingActions[i].tag.tagId,
        dataId: this.data[this.dataType.abbr + 'Id'],
        dataTypeId: this.dataType.dataTypeId
      };
      try {
        if (this.pendingActions[i].add) {
          await this.tagService.attachTag(payload);
        }
        else {
          await this.tagService.detachTag(payload);
        }
      }
      catch (err) {
        this.modal.close();
        this.updated.emit();
        this.toastService.throwToast(err.message);
      }
    }
    this.modal.close();
    this.updated.emit();
    this.toastService.throwToast('Tags updated successfully');
  }

  cancel() {
    this.pendingActions = [];
    this.modal.close();
  }

  addTags(tags: Array<Tag>) {
    tags.forEach(tag => {
      let doAdd = true; // ensure not a dupe
      // for each tag grouping
      for (const key in this.tagGroups) {
        if (this.tagGroups[key]) {
          // for each tag
          for (let i = 0; i < this.tagGroups[key].length; i++) {
            if (this.tagGroups[key][i].tagId === tag.tagId) {
              doAdd = false;
            }
          }
        }
      }

      if (doAdd) {
        this.tagGroups[tag.dataTypeId].push(tag);
        this.tagGroups[tag.dataTypeId].open = true;

        this.pendingActions.push({
          add: true,
          tag: tag
        });
      }
    });
  }

  deleteTag(tag: Tag) {
    // for each tag grouping
    for (const key in this.tagGroups) {
      if (this.tagGroups[key]) {
        // for each tag
        for (let i = 0; i < this.tagGroups[key].length; i++) {
          if (this.tagGroups[key][i].tagId === tag.tagId) {
            // delete selected
            this.tagGroups[key].splice(i, 1);
            this.pendingActions.push({
              add: false,
              tag: tag
            });
            return;
          }
        }
      }
    }
  }

  groupTags(tags: Array<Tag>): { [key: number]: Tag } {
    const tagGroups = {};
    if (tags) {
      for (let i = 0; i < tags.length; i++) {
        const dataTypeId = tags[i].dataTypeId;
        if (!tagGroups[dataTypeId]) {
          tagGroups[dataTypeId] = [];
        }
        tagGroups[dataTypeId].push(tags[i]);
        tagGroups[dataTypeId].open = true;
      }
    }

    // ensure one for each dataType exists
    this.dataTypes.forEach(dataType => {
      if (!tagGroups[dataType.dataTypeId]) {
        tagGroups[dataType.dataTypeId] = [];
        tagGroups[dataType.dataTypeId].open = false;
      }
    });

    return tagGroups;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/edit-tags/edit-tags.component.ts